import { render, staticRenderFns } from "./retencion.vue?vue&type=template&id=c39e97fe"
import script from "./retencion.vue?vue&type=script&lang=js"
export * from "./retencion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports